import { useMemo } from 'react';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { getFilteredScansByInbodyType } from '../../utils/getFilteredScansByInbodyType/getFilteredScansByInbodyType';

export const useFilterScansByInbodyType = (
  scansMetadata: ScanMetadata[],
  inbodyType: InbodyType | 'ALL' | undefined | null,
): ScanMetadata[] => {
  const filteredScans = useMemo(() => {
    return getFilteredScansByInbodyType(scansMetadata, inbodyType);
  }, [scansMetadata, inbodyType]);

  return filteredScans;
};
